"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRewardActiveList = void 0;
var types_1 = require("@pbl/pbl-react-core/lib/models/reward/types");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../../../config/constants"));
var action_1 = require("../../../../redux/reducers/rewards/action");
var useRewardActiveList = function () {
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), accessToken = _a.accessToken, account = _a.account;
    var loggedIn = !!accessToken && accessToken.length > 0 && !!account && !!account.email;
    var _b = (0, react_1.useState)([]), rewardTabsVisibility = _b[0], setRewardTabsVisibility = _b[1];
    (0, react_1.useEffect)(function () {
        var fetchDataForRewardTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _loop_1, _i, _a, type;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _loop_1 = function (type) {
                            var shouldShowTab, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        if (!(type === types_1.RewardType.COUPON || type === types_1.RewardType.GAMEPLAY || type === types_1.RewardType.EXTERNAL)) return [3, 2];
                                        return [4, (loggedIn ? action_1.fetchUserRewards : action_1.fetchRewards)(false, false, type)];
                                    case 1:
                                        _c = (_d.sent()).length > 0;
                                        return [3, 3];
                                    case 2:
                                        _c = true;
                                        _d.label = 3;
                                    case 3:
                                        shouldShowTab = _c;
                                        setRewardTabsVisibility(function (prevState) {
                                            var _a;
                                            return (__assign(__assign({}, prevState), (_a = {}, _a[type] = shouldShowTab, _a)));
                                        });
                                        return [2];
                                }
                            });
                        };
                        _i = 0, _a = constants_1.default.REWARD_TYPES.split(',');
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3, 4];
                        type = _a[_i];
                        return [5, _loop_1(type)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3, 1];
                    case 4: return [2];
                }
            });
        }); };
        fetchDataForRewardTypes();
    }, []);
    return { rewardTabsVisibility: rewardTabsVisibility };
};
exports.useRewardActiveList = useRewardActiveList;
//# sourceMappingURL=useRewardActiveList.js.map